import {css} from "@emotion/react";
import * as Yup from "yup";

import {FormikForm, IFormikSubmitFn} from "@pg-mono/formik-utils";

import {validationMessages} from "../../../form/utils/validation_messages";
import {useAppSelector} from "../../../store/hooks";
import {gtmEventFormInquiry} from "../../../tracking/google_tag_manager/gtm_event_form_inquiry";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {useEmailVerification} from "../../hooks/use_email_verification";
import {useHomeMatchPreferencesStorage} from "../../hooks/use_home_match_preferences_storage";
import {IApplicationAnalyticsData} from "../../tracking/tracking";
import {ApplicationVariant} from "../../types/ApplicationVariant";
import {IApplicationFormValues} from "../../types/IApplicationFormValues";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/ApplicationSource";
import {ApplicationFormBody} from "./ApplicationFormBody";
import {ApplicationFormContextProvider, IApplicationMessageLogic} from "./ApplicationFormContext";

interface IProps {
    // formik
    initialValues: IApplicationFormValues;
    onSubmit: IFormikSubmitFn<IApplicationFormValues>;
    onChange?: (formValues: IApplicationFormValues) => void;

    // tracking
    getAnalyticsData: () => IApplicationAnalyticsData; // analytics data is stored in context because it is needed not only on submit - hits are also triggered on form elements interaction.
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;

    // form field visibility
    alwaysShowFields?: boolean;
    hideMessageSection: boolean; // do not display message section (some forms are without it)
    hideQuestions?: boolean;
    hideRodo?: boolean;
    hideRooms?: boolean; // do not display rooms checkboxes (property forms do not display it)
    hideSubmitButton?: boolean;
    offerId?: number;

    // rest
    applicationMessageLogic: IApplicationMessageLogic;
    className?: string;
    formPreviouslySent: boolean; // we found LS-data, so form was previously sent
    onFormControlClick?: () => void; // callback for every form control click (previously described as `for every interaction`, but it was only called on click events - possible error?)
    storeHash: string;
    closeModal: () => void;
    submitOnMount?: boolean;
    applicationVariant?: ApplicationVariant;

    // post
    leadIsSubmitting: boolean;
    customFormText?: string;
    creditData?: {contribution: number; period: number};
    enablePreferencesStorage?: boolean;
}

const applicationSchema = Yup.object().shape({
    email: Yup.string().email().required(validationMessages.email),
    name: Yup.string().required(validationMessages.required),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().required(validationMessages.required)
    }),
    marketing_email: Yup.boolean().oneOf([true], validationMessages.required)
});

export const ApplicationForm = (props: IProps) => {
    const {hideRooms = false, submitOnMount} = props;
    const {props: emailNotificationProps, validateEmailOnce} = useEmailVerification();
    const {putPreferences} = useHomeMatchPreferencesStorage();

    const leadModalState = useAppSelector((state) => state.leadModal);
    const applicationData = useAppSelector((state) => state.application[props.storeHash]);

    const gtmData: IGTMEventLeadForm = {
        clickText: leadModalState.gtmMeta.openButtonSourceText ?? "",
        source: leadModalState.gtmMeta.openButtonSource ?? "",
        vendorName: (applicationData?.vendor?.detail?.name || applicationData?.vendor?.detail?.id.toString()) ?? "",
        offerName: (applicationData?.offer?.detail?.name || props.offerId?.toString()) ?? ""
    };

    const onSubmit: IFormikSubmitFn<IApplicationFormValues> = async (values, formikHelpers) => {
        if (!(await validateEmailOnce(values?.email))) {
            return;
        }

        gtmEventFormInquiry(gtmData.clickText, gtmData.source, gtmData.vendorName, gtmData.offerName);

        if (props.enablePreferencesStorage) {
            putPreferences({rooms: {lower: values.rooms[0], upper: values.rooms[1] || values.rooms[0]}});
        }

        return props.onSubmit(values, formikHelpers);
    };

    return (
        <FormikForm onSubmit={onSubmit} onChange={props.onChange} initialValues={props.initialValues} enableReinitialize validationSchema={applicationSchema}>
            <div css={scrollableForm}>
                <ApplicationFormContextProvider
                    leadIsSubmitting={props.leadIsSubmitting}
                    storeHash={props.storeHash}
                    emailNotificationProps={emailNotificationProps}
                    formPreviouslySent={props.formPreviouslySent}
                    onFormControlClick={props.onFormControlClick}
                    hideRooms={hideRooms}
                    hideMessageAndQuestionsSection={props.hideMessageSection}
                    hideSubmitButton={props.hideSubmitButton}
                    offerId={props.offerId}
                    applicationMessageLogic={props.applicationMessageLogic}
                    source={props.source}
                    sourceSection={props.sourceSection}
                    hideRodo={props.hideRodo}
                    getAnalyticsData={props.getAnalyticsData}
                    hideQuestions={props.hideQuestions}
                    alwaysShowFields={props.alwaysShowFields}
                    onCloseModal={props.closeModal}
                    customFormText={props.customFormText}
                    creditData={props.creditData}
                    applicationVariant={props.applicationVariant}
                >
                    <ApplicationFormBody submitOnMount={submitOnMount} applicationVariant={props.applicationVariant} />
                </ApplicationFormContextProvider>
            </div>
        </FormikForm>
    );
};

const scrollableForm = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
import {css} from "@emotion/react";
import * as Yup from "yup";

import {FormikForm, IFormikSubmitFn} from "@pg-mono/formik-utils";

import {validationMessages} from "../../../form/utils/validation_messages";
import {useAppSelector} from "../../../store/hooks";
import {gtmEventFormInquiry} from "../../../tracking/google_tag_manager/gtm_event_form_inquiry";
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {useEmailVerification} from "../../hooks/use_email_verification";
import {useHomeMatchPreferencesStorage} from "../../hooks/use_home_match_preferences_storage";
import {IApplicationAnalyticsData} from "../../tracking/tracking";
import {ApplicationVariant} from "../../types/ApplicationVariant";
import {IApplicationFormValues} from "../../types/IApplicationFormValues";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/ApplicationSource";
import {ApplicationFormBody} from "./ApplicationFormBody";
import {ApplicationFormContextProvider, IApplicationMessageLogic} from "./ApplicationFormContext";

interface IProps {
    // formik
    initialValues: IApplicationFormValues;
    onSubmit: IFormikSubmitFn<IApplicationFormValues>;
    onChange?: (formValues: IApplicationFormValues) => void;

    // tracking
    getAnalyticsData: () => IApplicationAnalyticsData; // analytics data is stored in context because it is needed not only on submit - hits are also triggered on form elements interaction.
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;

    // form field visibility
    alwaysShowFields?: boolean;
    hideMessageSection: boolean; // do not display message section (some forms are without it)
    hideQuestions?: boolean;
    hideRodo?: boolean;
    hideRooms?: boolean; // do not display rooms checkboxes (property forms do not display it)
    hideSubmitButton?: boolean;
    offerId?: number;

    // rest
    applicationMessageLogic: IApplicationMessageLogic;
    className?: string;
    formPreviouslySent: boolean; // we found LS-data, so form was previously sent
    onFormControlClick?: () => void; // callback for every form control click (previously described as `for every interaction`, but it was only called on click events - possible error?)
    storeHash: string;
    closeModal: () => void;
    submitOnMount?: boolean;
    applicationVariant?: ApplicationVariant;

    // post
    leadIsSubmitting: boolean;
    customFormText?: string;
    creditData?: {contribution: number; period: number};
    enablePreferencesStorage?: boolean;
}

const applicationSchema = Yup.object().shape({
    email: Yup.string().email().required(validationMessages.email),
    name: Yup.string().required(validationMessages.required),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().required(validationMessages.required)
    }),
    marketing_email: Yup.boolean().oneOf([true], validationMessages.required)
});

export const ApplicationForm = (props: IProps) => {
    const {hideRooms = false, submitOnMount} = props;
    const {props: emailNotificationProps, validateEmailOnce} = useEmailVerification();
    const {putPreferences} = useHomeMatchPreferencesStorage();

    const leadModalState = useAppSelector((state) => state.leadModal);
    const applicationData = useAppSelector((state) => state.application[props.storeHash]);

    const gtmData: IGTMEventLeadForm = {
        clickText: leadModalState.gtmMeta.openButtonSourceText ?? "",
        source: leadModalState.gtmMeta.openButtonSource ?? "",
        vendorName: (applicationData?.vendor?.detail?.name || applicationData?.vendor?.detail?.id.toString()) ?? "",
        offerName: (applicationData?.offer?.detail?.name || props.offerId?.toString()) ?? ""
    };

    const onSubmit: IFormikSubmitFn<IApplicationFormValues> = async (values, formikHelpers) => {
        if (!(await validateEmailOnce(values?.email))) {
            return;
        }

        gtmEventFormInquiry(gtmData.clickText, gtmData.source, gtmData.vendorName, gtmData.offerName);

        if (props.enablePreferencesStorage) {
            putPreferences({rooms: {lower: values.rooms[0], upper: values.rooms[1] || values.rooms[0]}});
        }

        return props.onSubmit(values, formikHelpers);
    };

    return (
        <FormikForm onSubmit={onSubmit} onChange={props.onChange} initialValues={props.initialValues} enableReinitialize validationSchema={applicationSchema}>
            <div css={scrollableForm}>
                <ApplicationFormContextProvider
                    leadIsSubmitting={props.leadIsSubmitting}
                    storeHash={props.storeHash}
                    emailNotificationProps={emailNotificationProps}
                    formPreviouslySent={props.formPreviouslySent}
                    onFormControlClick={props.onFormControlClick}
                    hideRooms={hideRooms}
                    hideMessageAndQuestionsSection={props.hideMessageSection}
                    hideSubmitButton={props.hideSubmitButton}
                    offerId={props.offerId}
                    applicationMessageLogic={props.applicationMessageLogic}
                    source={props.source}
                    sourceSection={props.sourceSection}
                    hideRodo={props.hideRodo}
                    getAnalyticsData={props.getAnalyticsData}
                    hideQuestions={props.hideQuestions}
                    alwaysShowFields={props.alwaysShowFields}
                    onCloseModal={props.closeModal}
                    customFormText={props.customFormText}
                    creditData={props.creditData}
                    applicationVariant={props.applicationVariant}
                >
                    <ApplicationFormBody submitOnMount={submitOnMount} applicationVariant={props.applicationVariant} />
                </ApplicationFormContextProvider>
            </div>
        </FormikForm>
    );
};

const scrollableForm = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
